import {Outlet} from "react-router-dom";
import {ModalContainer} from "reoverlay";

const GlobalLayout=()=>{

    return <>
        <Outlet/>
        <ModalContainer/>
    </>
}
export default GlobalLayout;